const namedExportToDefaultExport =
  (namedExport: string) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ [namedExport]: component }: Record<string, any>) => ({
    default: component,
  })

export { namedExportToDefaultExport }
